import { Component, inject } from '@angular/core';
import { ActivityPlaceService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ActivityPlaceCreateDto,
  ActivityPlaceDto,
  ActivityPlaceExcelDownloadDto,
  ActivityPlaceUpdateDto,
} from '../proxy/controlling/dtos/activity-place';
import { ACTIVITYPLACE_CONFIG, ACTIVITYPLACE_FIELDS } from './activity-place.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-activity-place',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ActivityPlaceService, ConfirmationService],
  templateUrl: './activity-place.html',
  styleUrl: './activity-place.scss',
})
export class ActivityPlace extends BaseCrudComponent<
  ActivityPlaceDto,
  ActivityPlaceCreateDto,
  ActivityPlaceUpdateDto,
  ActivityPlaceExcelDownloadDto
> {
  service = inject(ActivityPlaceService);
  config = ACTIVITYPLACE_CONFIG;
  fields = ACTIVITYPLACE_FIELDS;

  protected prepareUpdateDto(data: any, selected: ActivityPlaceDto): ActivityPlaceUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ActivityPlace';
  }
}
